module.exports = __webpack_public_path__ + "img/南师汉语.ad5f98b0.jpg";